const signInPageTranslations = {
  intro: {
    title: "مرحبًا بك!",
    subtitle: "أهلاً بك في أول تجربة تدريبية فريدة من نوعها عبر الإنترنت.",
    signUpText: "ليس لديك حساب؟",
    signUpLink: "إنشاء حساب",
  },
  heroSection: {
    brandingText: "تجربة تدريبية حصرية وفريدة من نوعها",
    hookText: "أنت على بعد خطوة واحدة من التجربة الحصرية التي تستحقها دائمًا.",
  },
  form: {
    email: "البريد الإلكتروني",
    password: "كلمة المرور",
    action: "تسجيل الدخول",
  },
};

export default signInPageTranslations;
